const noLinkDerby = (e, slug) => {
  if (slug === "/departamentos-venta/monterrico-eco-derby/") {
    e.preventDefault()
  }
}

export default noLinkDerby
